export const SAMPLES = {
  person: `{
  "name": "John Doe",
  "age": 30,
  "email": "john@example.com",
  "address": {
    "street": "123 Main St",
    "city": "Springfield",
    "zip": "62701"
  },
  "hobbies": ["reading", "cycling", "coding"],
  "active": true,
  "spouse": null
}`,
  math: `{
  "integer": 42,
  "negative": -17,
  "float": 3.14159265,
  "scientific": 6.022e23,
  "zero": 0,
  "big": 9007199254740991,
  "pi_approx": 3.141592653589793,
  "euler": 2.718281828459045
}`,
  types: `{
  "string": "Hello, World!",
  "number_int": 100,
  "number_float": 1.5,
  "boolean_true": true,
  "boolean_false": false,
  "null_value": null,
  "array": [1, "two", true, null, {"nested": "object"}],
  "object": { "key": "value", "deep": { "a": 1, "b": [2, 3] } }
}`,
  array: `[
  {"id": 1, "name": "Alice", "role": "Admin"},
  {"id": 2, "name": "Bob", "role": "User"},
  {"id": 3, "name": "Charlie", "role": "Moderator"},
  {"id": 4, "name": "Diana", "role": "User"},
  {"id": 5, "name": "Eve", "role": "Admin"}
]`,
  invalid: `{
  "name": "Broken JSON"
  "missing": "comma above",
  "trailing": [1, 2, 3,],
}`,
};
